import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import QRCode from "qrcode-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { generateQrCodeRequest, verifyProcessRequest } from "../../store/modules/qrCode/actions";
import { Container, Content, DemonstrationLogin, Info, AccessQrCode, ContainerQRCode } from "./styles";

export default function LoginQRCode() {
	const dispatch = useDispatch();
	const auth_token = useSelector((state) => state.qrCode.auth_token);

	useEffect(() => {
		function generateQrCode() {
			dispatch(generateQrCodeRequest());
		}

		generateQrCode();
	}, [dispatch]);

	useEffect(() => {
		function verifyProcess(auth_token) {
			dispatch(verifyProcessRequest(auth_token));
		}

		if (auth_token) {
			var interval = setInterval(() => {
				verifyProcess(auth_token);
			}, 5000);
		}
		return () => {
			clearInterval(interval);
		};
	}, [auth_token, dispatch]);

	return (
		<Container>
			<Content>
				<DemonstrationLogin>
					<Info>
						<span>1. Abra o aplicativo TradeMap no seu celular</span>
						<span>
							2. Toque em&nbsp;<b>Perfil</b>&nbsp;e depois
							em&nbsp;<b>Acesso ao portal</b>
						</span>
						<span>
							3. Aponte a câmera do celular e escaneie o QR Code
							abaixo {":)"}
						</span>
					</Info>
				</DemonstrationLogin>
				<AccessQrCode>
					<ContainerQRCode>
						{!Boolean(auth_token) ? (
							<CircularProgress style={{ color: "#FFFF" }} />
						) : (
							<QRCode
								value={auth_token}
								bgColor="#23242F"
								fgColor="#FFFF"
								size={192}
							/>
						)}
					</ContainerQRCode>
				</AccessQrCode>
			</Content>
		</Container>
	);
}
